import React from 'react'
import { Button, Callout, FormGroup, InputGroup, Intent, Checkbox, Icon, Popover, PopoverPosition, Label } from '@blueprintjs/core'
import cx from 'classnames'
import { lang, toast } from 'enablex/shared'
import style from './style.scss'
import { BotCard } from './BotCard'

export const Bots = ({config}) => {
    return <>
        <div className={style.containerLeft}>
            <div>
                <div className={style.filterWrapper}>
                    <div className={style.pageTitle}>BOTs</div>
                    <Button
                        id="btn-new-bot"
                        text={lang.tr('admin.workspace.bots.new')}
                        icon="add"
                        intent="primary"
                        className={style.newBotButton}
                        style={{
                            backgroundColor: config?.themeColor || '#1d6c90'
                        }}
                    // onClick={this.createNewBotUrl.bind(this)}
                    />
                </div>

                <div className={cx(style.bot_views, style.compact_view)}>
                    <BotCard config={config} />
                </div>
            </div>
        </div>
    </>
}
